import { Component, inject } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";

import { NgbDatepickerConfig } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "./service/auth/auth-service.service";
import { ToastsContainer } from "./service/toast-service/toast-container/toast-container.component";

@Component({
    selector: "app-root",
    standalone: true,
    imports: [RouterOutlet, ToastsContainer],
    providers: [NgbDatepickerConfig],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss"
})
export class AppComponent {
    title = "client-app";
    authService: AuthService = inject(AuthService);
    private router: Router = inject(Router);
    private calendarService = inject(NgbDatepickerConfig);

    constructor() {
        this.calendarService.weekdays = "short";
    }

    logOut() {
        this.authService.logout().subscribe({
            next: (status) => {
                console.log;
                this.router.navigate(["login"]);
            }
        });
    }
}
